import React from 'react';
import { cleanHtml } from '../../actions';
import Navlist from '../navigation/Navlist';

export const MultiImagePage = ({data,showingAll}) => {
  let subItemData = [];

  if (data.subItems.length > 0) {
    let orderItems = data.subItems;
    orderItems.sort(function(a, b) {
      return Number(a.displayOrder|| 0) - Number(b.displayOrder|| 0);
    });
    orderItems.forEach(
      item => subItemData.push(item),
    );
  }

  let title = data.title;
  let content = cleanHtml(data.content);
  let cols = (showingAll) ? "12" : "8";
  return (
    <div className="container">
      <div className="row">
        <div className={`col-md-${cols}`}>
          <div className="row">
            <div className="col-md-12">
              <div className="custom-heading-01">
                <h2>{title}</h2>
                {data.speakers && 
                <p>{<b>Speakers:</b>}{` `}{data.speakers}</p>
                }
                <div style={{marginBottom: 30+'px'}}>
                  {data.youtube && 
                  <a 
                    className="btn btn-success icon-animated" 
                    href={data.youtube}
                    target="_blank"
                    style={{backgroundColor: 'rgb(92, 184, 92)', marginRight: 20+'px'}}>
                      <span style={{color: 'white', marginBottom: 0}}>
                        <i className="lynny-tv"></i>Video
                      </span>
                  </a>
                  }
                  {data.flyer && 
                  <a 
                    className="btn btn-success icon-animated" 
                    href={data.flyer}
                    target="_blank"
                    style={{backgroundColor: 'rgb(92, 184, 92)', marginRight: 20+'px'}}>
                      <span style={{color: 'white', marginBottom: 0}}>
                        <i className="lynny-download"></i>Download Flyer
                      </span>
                  </a>
                  }
                </div>
              </div>
              <p dangerouslySetInnerHTML={{ __html: content }}></p>
            </div>
          </div>
          <div className="row mb-80">
            {subItemData.map((item, i) => {
              let img = (item.imageUrl) ? item.imageUrl : '/img/user.PNG';
              return (
                <div key={i} className="col-sm-4 blog-posts blog-list" style={{height: 360+'px'}}>
                  <div className="post-container">
                    <div className="post-media">
                      <img src={img} alt={item.title} style={{
                        height:'auto', 
                        maxWidth: 210+'px',
                        maxHeight: 260+'px'
                      }}/>
                    </div>
                    <div className="post-body">
                      <h4 style={{ marginBottom: 0+'px' }}>{item.title}</h4>
                      <p>{item.text}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <hr />
        </div>
        {!showingAll && 
        <aside className="col-md-4 aside-right">
          <ul className="aside-widgets">
            <li className="widget widget_nav_menu clearfix">
              <Navlist pageId={data.id} />
            </li>
          </ul>
        </aside>
        }
      </div>
    </div>
  );
}

export default MultiImagePage;
